import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.75 3.375v11.25a1.125 1.125 0 0 1-1.125 1.125H9.563a.563.563 0 0 1 0-1.125h5.062V3.375H3.375v6.75a.562.562 0 1 1-1.125 0v-6.75A1.125 1.125 0 0 1 3.375 2.25h11.25a1.125 1.125 0 0 1 1.125 1.125m-6.914 7.477a.56.56 0 0 0-.796 0l-3.54 3.54-1.29-1.29a.564.564 0 0 0-.795.796l1.687 1.688a.56.56 0 0 0 .796 0l3.938-3.938a.563.563 0 0 0 0-.796"
    }, null, -1)
  ])))
}
export default { render: render }